const Footer = () => {
    return ( 
        <div className="footer-wrapper">
            <span>© Sahil patra {new Date().getFullYear()}</span>
        </div>
     );
}
 
export default Footer;